import React, { useEffect, useState } from 'react';
import styles from './VoiceComplete.module.css';
import { ContainerNoTop } from '../layout';


const VoiceComplete = () => {
    return (
        // <ContainerNoTop> 
            <div className={styles.authContainer}>
                <h1 className={styles.authTitle}>Thank you for showing up and sharing what you feel.</h1>
                <h3>You help us understand what is really happening, and that understanding is what drives meaningful change.</h3>
            </div>
        // </ContainerNoTop>
    );
};

export default VoiceComplete;